module.exports = __webpack_public_path__ + "img/mudlingdead.f47d49cc.png";